module.exports = __webpack_public_path__ + "img/inception.1955bd3e.svg";